function Features() {
  return (
    <section className="py-5" id="features">
      <div className="container">
        <div className="row py-4">
          <div className="col-lg-12">
            <div className="text-center animate-on-scroll">
              <h1 className="mt-0">
                <i className="mdi mdi-infinity"></i>
              </h1>
              <h2 className="fw-bold">
                All-in-One <span className="text-primary">Sportswear</span>{" "}
                Business <span className="text-primary">Platform</span>
              </h2>
              <p className="text-muted mt-2 lead">
                From lead generation to product delivery, OrderRun handles
                every aspect of your business.
                <br />
                Built specifically for sportswear manufacturers who demand
                excellence.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4 animate-on-scroll">
            <div className="text-center p-2 p-sm-3 feature-card h-100 bg-white rounded shadow-sm">
              <div className="avatar-sm m-auto">
                <span className="avatar-title bg-primary-lighten rounded-circle">
                  <i className="mdi mdi-account-multiple text-primary font-24"></i>
                </span>
              </div>
              <h4 className="mt-3">Customer Management</h4>
              <p className="text-muted mt-2 mb-0">
                Complete CRM with customer profiles, communication history, and
                detailed tracking for building lasting relationships.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4 animate-on-scroll">
            <div className="text-center p-2 p-sm-3 feature-card h-100 bg-white rounded shadow-sm">
              <div className="avatar-sm m-auto">
                <span className="avatar-title bg-primary-lighten rounded-circle">
                  <i className="mdi mdi-file-document-outline text-primary font-24"></i>
                </span>
              </div>
              <h4 className="mt-3">Quotes & Work Orders</h4>
              <p className="text-muted mt-2 mb-0">
                Create professional quotes, convert to work orders, and track
                every step from approval to completion.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4 animate-on-scroll">
            <div className="text-center p-2 p-sm-3 feature-card h-100 bg-white rounded shadow-sm">
              <div className="avatar-sm m-auto">
                <span className="avatar-title bg-primary-lighten rounded-circle">
                  <i className="mdi mdi-factory text-primary font-24"></i>
                </span>
              </div>
              <h4 className="mt-3">Manufacturing Control</h4>
              <p className="text-muted mt-2 mb-0">
                Manage production orders, track material inventory, monitor
                employee attendance, and analyze production efficiency.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4 animate-on-scroll">
            <div className="text-center p-2 p-sm-3 feature-card h-100 bg-white rounded shadow-sm">
              <div className="avatar-sm m-auto">
                <span className="avatar-title bg-primary-lighten rounded-circle">
                  <i className="mdi mdi-package-variant text-primary font-24"></i>
                </span>
              </div>
              <h4 className="mt-3">Inventory Management</h4>
              <p className="text-muted mt-2 mb-0">
                Track material stock, manage purchase orders, handle vendors,
                and monitor material issues in real-time.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4 animate-on-scroll">
            <div className="text-center p-2 p-sm-3 feature-card h-100 bg-white rounded shadow-sm">
              <div className="avatar-sm m-auto">
                <span className="avatar-title bg-primary-lighten rounded-circle">
                  <i className="mdi mdi-chart-line text-primary font-24"></i>
                </span>
              </div>
              <h4 className="mt-3">Analytics & Reports</h4>
              <p className="text-muted mt-2 mb-0">
                Comprehensive reporting, loss run analysis, audit trails, and
                real-time dashboards for data-driven decisions.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4 animate-on-scroll">
            <div className="text-center p-2 p-sm-3 feature-card h-100 bg-white rounded shadow-sm">
              <div className="avatar-sm m-auto">
                <span className="avatar-title bg-primary-lighten rounded-circle">
                  <i className="mdi mdi-shield-check text-primary font-24"></i>
                </span>
              </div>
              <h4 className="mt-3">Security & Permissions</h4>
              <p className="text-muted mt-2 mb-0">
                Role-based access control, secure password management, and
                encrypted data storage for complete security.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
